import React, { useMemo } from 'react'

import { ComboBox, ComboBoxChange, ComboBoxOption } from 'components/ComboBox'

import { useCompanyDetail } from '../../../hooks/useCompanyDetail'

import type { ContactMaster } from './types'

type Props = {
  id?: string
  tenantId: string | null
  warehouseId: string | null
  companyId: string | null
  value: string
  onChange: (next: ComboBoxChange) => void
  onSelectMaster?: (master: ContactMaster) => void
  isLocked?: boolean
  onClear?: () => void
  disabled?: boolean
}

export const VehicleControllerComboBox: React.FC<Props> = ({
  id,
  tenantId,
  warehouseId,
  companyId,
  value,
  onChange,
  onSelectMaster,
  isLocked,
  onClear,
  disabled,
}) => {
  const { companyDetail, isLoading } = useCompanyDetail({
    tenantId,
    warehouseId,
    companyId,
    type: 'vehicle_controller',
  })

  const controllers = companyDetail?.driversControllers.data ?? []

  const options = useMemo<ComboBoxOption[]>(
    () =>
      controllers
        .filter((c) => c.attributes.name)
        .map((c) => ({ label: c.attributes.name as string, value: c.id })),
    [controllers]
  )

  const handleChange = (next: ComboBoxChange) => {
    onChange(next)
    if (next.value && onSelectMaster) {
      const controller = controllers.find((c) => c.id === next.value)
      if (controller) {
        onSelectMaster({
          phone: controller.attributes.telNumber,
          email: controller.attributes.email,
        })
      }
    }
  }

  return (
    <ComboBox
      id={id}
      options={options}
      value={value}
      onChange={handleChange}
      isLocked={isLocked}
      onClear={onClear}
      disabled={disabled}
      isLoading={isLoading}
    />
  )
}
